<template>
  <v-container>
    <h2 class="pt-5">Search Caregivers/ Maids/ Confinement Nannies</h2>
    <p class="pt-3">
      Search through our list of profiles to find a suitable match for your
      family. Do contact us and provide us with your requirements so that we can
      better advice, source and screen suitable helpers for you.
      <br />
      <br />
      <b
        >** Kindly WhatsApp/Call to check on availability of caregivers/helpers
        as the website may not be up-to-date.</b
      >
      <br />
      <b>** Not all of available caregivers' biodata are available online.</b>
    </p>

    <br />
    <div class="row" :v-slot:default="{ hover }">
      <v-card
        max-width="275"
        :class="`elevation-${hover ? 24 : 6}`"
        class="mx-auto pa-6 col-md-4 col-sm-4 col-lg-4"
        v-for="info in data"
        :key="info.fdwId"
      >
        <v-img :src="info.profileImg" height="260" class="profileImage"></v-img>
        <div id="name">
          <br />
          <h2 class="">{{ info.fdwName }}</h2>
        </div>

        <p class="pt-2">
          <b>{{ info.webInfo.title }}</b>
        </p>

        <div class="pt-2">
          <div v-for="(item, index) in tagArray" :key="index">
            <!-- get the matching tag value from array matching to fdwId -->
            <div v-if="item.fdwId == info.fdwId">
              <div>
                <v-btn
                  v-for="(tag, tagIndex) in item.value.split('|')"
                  :key="tagIndex"
                  class="white--text"
                  x-small
                  :style="{ backgroundColor: tagColorCode[tagIndex] }"
                  ><b>{{ tag }}</b>
                </v-btn>
              </div>
            </div>
          </div>

          <v-card-actions>
            <v-spacer></v-spacer>
          </v-card-actions>

          <v-divider></v-divider>
        </div>
        <div>
          <p class="pt-4" v-html="info.webInfo.shortDesc"></p>
        </div>

        <br />
        <br />
        <br />
        <br />
        <div class="pl-4 pt-5 btnCls">
          <v-btn
            color="red accent-4"
            @click.stop="$set(dialog, info.fdwId, true)"
            dark
            class="mt-5 mb-4 detailBtn"
            large
          >
            <b>See More Details</b>
          </v-btn>
        </div>
        <br />
        <div class="pl-4 pt-5">
          <v-btn
            color="red accent-4"
            dark
            class="mt-5 mb-4 detailBtn2"
            :href="
              'https://api.whatsapp.com/send?phone=6580688811&text=I%20am%20interested%20in%20hiring%20your%20helper%20%28' +
                info.fdwName +
                '%29for%20my%20household'
            "
            target="_blank"
            large
          >
            <b> WhatsApp us</b>
          </v-btn>
        </div>
        <br />
        <!-- popup -->
        <v-dialog
          v-model="dialog[info.fdwId]"
          :key="info.fdwId"
          max-width="630"
        >
          <v-card class="pl-4 pr-4 pb-4 pt-4">
            <v-icon color="red accent-4" @click="dialog[info.fdwId] = false">
              mdi-close-circle
            </v-icon>
            <v-row>
              <v-col lg="6" md="6" sm="12">
                <v-img
                  :src="info.profileImg"
                  class="profileImage"
                  height="350"
                ></v-img>
              </v-col>
              <v-col lg="6" md="6" sm="12">
                <br />
                <h1 class="pl-4 name">{{ info.fdwName }}</h1>

                <p class="pl-4">
                  <b>{{ info.webInfo.title }}</b>
                </p>

                <div class="pl-4 pt-4">
                  <div v-for="(item, index) in tagArray" :key="index">
                    <!-- get the matching tag value from array matching to fdwId -->
                    <div v-if="item.fdwId == info.fdwId">
                      <div>
                        <v-btn
                          x-small
                          v-for="(tag, tagIndex) in item.value.split('|')"
                          :key="tagIndex"
                          class="white--text"
                          :style="{ backgroundColor: tagColorCode[tagIndex] }"
                          ><b>{{ tag }}</b>
                        </v-btn>
                      </div>
                    </div>
                  </div>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                  </v-card-actions>

                  <v-divider></v-divider>
                </div>

                <div class="pt-3 pl-4 summary">
                  <i> <p v-html="info.webInfo.summary"></p></i>
                </div>
              </v-col>
            </v-row>

            <v-row class="pt-3 pl-5 pr-5 longdecs">
              <p v-html="info.webInfo.longDesc"></p>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </div>

    <br />
    <br />

    <v-card
      elevation="2"
      color="light-green lighten-5"
      class="pt-3 pl-3 pb-3 pr-3"
    >
      <h2 style="text-align: center" class="mt-5">
        More Available Biodatas for <br />Caregivers and Migrant Domestic<br />
        Workers
      </h2>
      <h4 style="text-align: center" class="mt-5">
        Search through our list to find the right match! Do also contact our
        Consultant if you have specific requirements!
      </h4>
      <div class="text-center mt-5">
        <v-btn
          color="red accent-4"
          dark
          class="mt-5 mb-4"
          href="https://api.whatsapp.com/send?phone=6580688811"
          target="_blank"
          large
        >
          <b> WhatsApp us >> </b>
        </v-btn>
      </div>
    </v-card>
  </v-container>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
    show: true,
    dialog: {},
    data: [],
    details: [],
    tagArray: [],
    tagColorCode: [
      "#004d1a",
      "#0040ff",
      "#ff0000",
      "#008000",
      "#000080",
      "#800000",
      "#43302E",
      "#36013F",
      "#000000",
    ],
  }),
  mounted() {
    this.getProfileDetails();
  },
  methods: {
    getProfileDetails() {
      axios
        .get("https://joan.maidagencysoftware.com/api/routes/get-fdw-info.php")
        .then((response) => {
          console.log(response);
          this.data = response.data.data;

          var t = 0;
          for (const element of this.data) {
            this.tagArray.push({
              fdwId: response.data.data[t].fdwId,
              value: response.data.data[t].webInfo.tag,
            });
            t++;
          }
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    },
  },
};
</script>
<style scoped>
.name {
  color: green;
}
.summary {
  text-align: justify;
}
.longdecs {
  text-align: justify;
}
#name {
  color: green;
}
.profileImage {
  -webkit-filter: blur(5px);
  -moz-filter: blur(5px);
  -o-filter: blur(5px);
  -ms-filter: blur(5px);
  filter: blur(5px);
}

.detailBtn {
  position: absolute;
  bottom: 60px;
  width: 170px;
}
.detailBtn2 {
  position: absolute;
  bottom: 0px;
  width: 170px;
}
.v-card {
  margin-bottom: 30px;
}
</style>
